<template>
  <el-dialog :title="dialogConf.title" :visible.sync="visible" width="400px">
    <div v-if="dialogConf.type === 1">解除后将不再从网约钱包划扣资金，是否确认解除？</div>
    <div v-else-if="dialogConf.type === 2" class="zfbContent">
      <div class="zfbTips">操作说明：解除后，您的资金划扣服务将立即终止。如需再次开启，请重新进行签约授权操作。</div>
      <div style="display: flex">
        <div>支付宝账号</div>
        <div style="margin-left:10px; font-weight: bold">{{ customer.customerName }}（{{ customer.customerThirdLoginId }}）
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="run(handleConfirmCancel)">{{ needDingTalkApprove ? '发起解除审批' : '确认解除' }}</el-button>
    </span>
  </el-dialog>
</template>
<script setup>
import { getSubmitDingTalkShow } from '@/api/global'
import { cancelAlipayWithhold, cancelWalletWithhold, getPersonWithholdCustomerInfo } from '@/api/withhold.js'
import { Message } from '@qs/ui'
import { ref } from 'vue'
import { WITHHOLD_TYPE } from './const'
import { useSubmitLock } from '@/utils/useUtils'

const emit = defineEmits(['update'])
// 解约API
const cancelWithhold = {
  [WITHHOLD_TYPE.WALLET]: cancelWalletWithhold, // 网约钱包支付
  [WITHHOLD_TYPE.ALIPAY]: cancelAlipayWithhold, // 支付宝支付
}

// 审批流业务ID
const bizTypeValue = {
  [WITHHOLD_TYPE.WALLET]: 5, // 5网约钱包支付
  [WITHHOLD_TYPE.ALIPAY]: 4, // 4 支付宝支付
}
const open = (conf = {}) => {
  dialogConf.value = {
    ...defaultConfig,
    ...conf,
  }
  if (conf.type === WITHHOLD_TYPE.ALIPAY) {
    getCustomerInfo(conf.orderId)
  }
  getSubmitDingTalkState(bizTypeValue[conf.type])
}

// 获取司机信息
const getCustomerInfo = async (orderId) => {
  const { code, data } = await getPersonWithholdCustomerInfo({ orderId, type: bizTypeValue[WITHHOLD_TYPE.WALLET] })
  if (code === 1) {
    customer.value = data
  }
}
// 获取是否需要钉钉审批
const getSubmitDingTalkState = (bizType) => {
  getSubmitDingTalkShow({
    bizType,
  }).then(({ code, data }) => {
    if (code === 1) {
      needDingTalkApprove.value = data
      visible.value = true
    }
  })
}

const close = () => {
  visible.value = false
  emit('update')
}

const handleConfirmCancel = async () => {
  const { orderId, type } = dialogConf.value
  const { code } = await cancelWithhold[type]({
    orderId,
  })
  if (code === 1) {
    Message.success(needDingTalkApprove.value ? '提交成功' : '解除成功')
    close()
  }
}

const defaultConfig = {
  orderId: '',
  title: '',
  type: '',
}

const customer = ref({})
const needDingTalkApprove = ref(false)
const dialogConf = ref(defaultConfig)
const visible = ref(false)

const { loading: submitLoading, run } = useSubmitLock()
defineExpose({
  open,
})
</script>
<script>
export default {
  name: 'UnBindWithhold',
}
</script>
<style lang="scss" scoped>
.zfbTips {
  font-size: 14px;
  background: #EBF5FE;
  color: #3154AF;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
}
.zfbContent {
  padding-bottom: 10px;
  border-bottom: 1px solid #EBF5FE;
}
</style>
